import {Type} from 'main.core';

export class Img
{
	constructor(options = {name: 'Img'})
	{
		this.name = options.name;
	}

	setName(name)
	{
		if (Type.isString(name))
		{
			this.name = name;
		}
	}

	getName()
	{
		return this.name;
	}
}